import MachineState from '../../../../../shared/model/MachineState';

export class MachineCreateRequest {

    // WorkerContractorSave {
    //   contractor_id: number
    //   document_schema_id: number
    // }

    _brand; // string
    _model; // string
    _description; // string
    _contractors; // MachineContractorSave[]
    _licencePlate; // string
    _machineTypeId; // number
    _machineStateId; // number

    constructor(values) {
        this._brand = values.brand;
        this._model = values.model;
        this._description = values.description;
        this._contractors = this._parseContractorSchemas(values);
        this._licencePlate = values.licensePlate;
        this._machineTypeId = undefined; // TODO(PAVASALEVO-582): comentarios
        this._machineStateId = values.state ? MachineState.ACTIVE : MachineState.INACTIVE;
    }

    body() {
        return {
            name: this._licencePlate,
            brand: this._brand,
            model: this._model,
            notes: this._description,
            contractors: this._contractors,
            machine_type_id: this._machineTypeId,
            machine_state_id: this._machineStateId,
        };
    }

    _parseContractorSchemas(values) {
        return values
            .contractorSchemas
            .filter(s => s.schema.length !== 0)
            .map((s) => ({
                contractor_id: s.contractorId,
                document_schema_id: s.schema[0].value,
            }));
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/create/machine-create/MachineCreateRequest.js